<template>
	<div class="body" v-loading="loading" element-loading-text="努力分析中...">
		<div class="body-container">

			<el-table :data="list" border stripe>
				<el-table-column label="序号" align="center" prop="index">
				</el-table-column>
				<el-table-column label="岗位名称" align="center" prop="name">
				</el-table-column>
				<el-table-column label="典型工作任务" align="left" prop="content">
					<template v-slot="{ row }">
						<div class="wrap-content">{{formatTextWithLineBreaks(row.content)}}</div>
					</template>
				</el-table-column>
			</el-table>

		</div>

		<div class="action-ctr">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickCareer()"
				class="next-btn">生成专业（群）建设分析报告</el-button>
		</div>


	</div>
</template>

<script>
	import {
		queryJobAttrData
	} from "@/api/matrix"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				title: '',
				list: [],
				spanMap: {},
				params: {
					page: 1,
					pageSize: 20
				},
				total: 0,
				showCareerDialog: false,
				acceptMap: {},
				careerData: null,
				showCreateDialog: false,
				companyName: '',
				jobName: '',
				jobDescription: '',
				loading: true
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.requestData();
			},

			requestData() {
				let that = this;
				this.id = this.$route.query.id;
				this.params['id'] = this.id;
				queryJobAttrData(this.params).then(res => {
					console.log('groupId', this.groupId)
					let realData = res.data;
					
					if (realData['done'] != 1){
						setTimeout(function(){
							that.requestData();
						}, 1000)
					}else{
						this.list = realData.list;
						this.loading = false;
					}
					
					// this.title = realData.title;
				});
			},
			
			
			// 方法：格式化文本
			formatTextWithLineBreaks(text) {
				text = text.replaceAll('；', '；\n')
				text = text.replaceAll(';', '；\n')
				return text;
			},
			

		
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "target_job.scss";
</style>